module.exports = __webpack_public_path__ + "img/404_icon.fa65b927.png";